import FlowConfigBase from '#client/config/FlowConfigBase';
import AUTH_POLICY from '#client/constants/authPolicy';
import {
  ENABLE_CORA_UPSELLS,
  CVR267_COMPLIANCE_TIER_CROSS_SELL // Remove this changes when the PR is approved
} from '#client/constants/experimentFlags';
import * as ROUTES from '#client/constants/routes';
import { ENTITLED_SKIP, FORMATION_PLAN_SKIP } from '#client/utils/flowPageSkips';

import PAGES, { PAGE_KEYS } from '../flowPageConfig';

export default FlowConfigBase.createEntry({
  id: 'change-of-registered-agent',
  pageKeys: [
    PAGE_KEYS.BUSINESS_INFO_CORA,
    PAGE_KEYS.CONTACT_INFO,
    PAGE_KEYS.CHANGE_OF_REGISTERED_AGENT,
    PAGE_KEYS.REGISTERED_AGENT_AND_WFC,
    PAGE_KEYS.MULTI_STATE_REGISTERED_AGENT,
    PAGE_KEYS.MONEY_PRO,
    PAGE_KEYS.CHECKOUT,
    PAGE_KEYS.CONCLUSION
  ],
  pageConfigs: {
    [PAGES.BUSINESS_INFO_CORA.pageComponent]: {
      pageComponentProps: {
        slotProps: {
          calloutAsset: { name: 'cora-get-started' },
          largeColumnOrder: {
            calloutAsset: 2,
            constructorCallout: 1
          },
          subtitle: { messageKey: 'businessInfoCORA' }
        }
      }
    },
    [PAGES.REGISTERED_AGENT_AND_WFC.pageComponent]: {
      pageComponentProps: {
        couponCodes: {
          ra_pro_plan_v3: 'ra_pro_plan_v3_199',
          ra_starter_plan_v3: 'ra_starter_plan_v3_100'
        }
      }
    },
    [PAGES.CHECKOUT.pageComponent]: {
      pageComponentProps: {
        slotProps: {
          businessCardProps: {
            businessInfoFields: {
              businessName: {
                disabled: true
              }
            }
          }
        }
      }
    },
    [PAGES.CONTACT_INFO.pageComponent]: {
      pageComponentProps: {
        slotProps: {
          calloutAsset: { name: 'cora-funnel-info' },
          pageHeader: { messageKey: 'contactInfoBOI' }
        }
      }
    },
    [PAGES.MULTI_STATE_REGISTERED_AGENT.pageComponent]: {
      pageComponentProps: {
        slotProps: {
          calloutAsset: { name: 'cora-funnel-info' },
          pageHeader: { messageKey: 'contactInfoBOI' }
        },
        couponCodes: {
          ra_pro_plan_v3: 'ra_pro_plan_v3_199',
          ra_starter_plan_v3: 'ra_starter_plan_v3_100'
        }
      }
    },
    [PAGES.CONCLUSION.pageComponent]: {
      pageComponentProps: {
        slotProps: {
          calloutAsset: { name: 'boi-funnel-conclusion' },
          nextSteps: {
            messageKey: 'shopping.page.conclusionCORA',
            activeStep: 3,
            stepsCount: 4,
            primaryAction: {
              href: ROUTES.COMPLETE_CORA
            }
          },
          pageHeader: {
            hideBack: true,
            messageKey: 'shopping.page.conclusionCORA'
          }
        }
      }
    },
    [PAGES.MONEY_PRO.pageComponent]: {
      skips: [FORMATION_PLAN_SKIP, ENTITLED_SKIP] // TODO: add feature flag skip on follow-up PR as part of ACQ-8857
    }
  },
  screensToSkipByService: [
    {
      pathToValidate: 'advanced-compliance',
      skipInService: 'ra_starter_plan_v3'
    },
    {
      pathToValidate: 'basic-compliance',
      skipInService: 'ra_pro_plan_v3'
    }
  ],
  autoLoadBusiness: true,
  authRedirect: ROUTES.LEGACY_CORA,
  authRedirectOverrides: {
    [PAGES.CONCLUSION.path]: ROUTES.COMPLETE_CORA,
    [PAGES.CHECKOUT.path]: ROUTES.COMPLETE_CORA
  },
  authRequired: false,
  authPolicy: AUTH_POLICY.NOT_ENFORCED,
  disableCartCreation: false,
  entityType: 'llc',
  hasFormation: false, // TODO: this can be dynamically computed based on the pages
  isPrimary: true,
  postOrderAutoLogin: true,
  postOrderRedirect: `${ROUTES.SHOP_CORA}/${PAGES.CONCLUSION.path}`,
  priceListUuids: {
    development: '7bf3a28f-e243-418d-b086-a9024eda2121',
    production: 'd0d5ff6e-ac47-43ed-8294-6188e014a6de'
  },
  version: 1,
  currentExperiment: CVR267_COMPLIANCE_TIER_CROSS_SELL,
  featureFlags: {
    [CVR267_COMPLIANCE_TIER_CROSS_SELL]: {
      merge: {
        type: 'replace'
      },
      variations: {
        control: {},
        variant: {
          pageKeys: [
            PAGE_KEYS.BUSINESS_INFO_CORA,
            PAGE_KEYS.CONTACT_INFO,
            PAGE_KEYS.CHANGE_OF_REGISTERED_AGENT,
            PAGE_KEYS.REGISTERED_AGENT_AND_WFC,
            PAGE_KEYS.ADVANCED_COMPLIANCE,
            PAGE_KEYS.BASIC_COMPLIANCE,
            PAGE_KEYS.MULTI_STATE_REGISTERED_AGENT,
            PAGE_KEYS.MONEY_PRO,
            PAGE_KEYS.CHECKOUT,
            PAGE_KEYS.CONCLUSION
          ]
        }
      }
    },
    [ENABLE_CORA_UPSELLS]: {
      isExperiment: false, // no event needed
      merge: {
        type: 'insert', // Type can be 'insert' or 'replace'
        inKey: 'pageKeys', // Required if type is 'insert'
        afterValue: PAGE_KEYS.REGISTERED_AGENT_AND_WFC // Required if type is 'insert'
      },
      variations: {
        control: {},
        variant: [PAGE_KEYS.EIN],
        variant_2: [PAGE_KEYS.BOI],
        variant_3: [PAGE_KEYS.EIN, PAGE_KEYS.BOI]
      }
    }
  }
});
